module.exports = __webpack_public_path__ + "img/photo6.782bbd50.png";